// extracted by mini-css-extract-plugin
export var avatarContainer = "_bk-0";
export var avatarTypingWave = "_bk-i";
export var gray = "_bk-f";
export var green = "_bk-c";
export var icon = "_bk-9";
export var image = "_bk-1";
export var lg = "_bk-6";
export var md = "_bk-5";
export var presenceDot = "_bk-b";
export var red = "_bk-d";
export var sm = "_bk-4";
export var status = "_bk-a";
export var typingDot = "_bk-h";
export var typingPill = "_bk-g";
export var xl = "_bk-7";
export var xs = "_bk-3";
export var xxl = "_bk-8";
export var xxs = "_bk-2";
export var yellow = "_bk-e";